<template>
  
  <div>
    <Preloader v-if="preloader" />
     
        <v-row>
      <v-col
        cols="12"
        md="9"
      >
        <v-card>
         
    <v-tabs
      v-model="tab"
      background-color="light-green"
      fixed-tabs
      dark
      
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        Recurring Timelapse
       </v-tab>

      <v-tab href="#tab-2" >
       One Time  Timelapse
        
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        value="tab-1"
      >
        <v-card flat>
               <v-alert
      dense
      text
      :type="alertType"
      v-if="alert"
    >
     {{ alertmessage }}
    </v-alert>

    <v-form
    ref="form"
   
    @submit.prevent="submit"
  > 
       <v-card  class="pa-5" >
      <v-radio-group
              v-model="recurringtype"
              column
            >
              <v-radio
                label="Daily"
                color="light-green"
                value="1 day"
              ></v-radio>
               <v-radio
                label="Weekly"
                color="light-green"
                value="1 week"
              ></v-radio>
              
               <v-radio
                label="Monthly"
                color="light-green"
                value="1 month"
              ></v-radio>
               
            </v-radio-group>
        <v-row>
        <v-col
      cols="11"
      sm="5"
    >
      <v-menu
        ref="menu"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time1"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        color="light-green"
      >
        <template v-slot:activator="{ on, attrs }" color="light-green">
          <v-text-field
            v-model="time1"
            label="Start time "
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            
            v-on="on"
            format="24hr"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="menu2"
          v-model="time1"
          full-width
          format="24hr"
          @click:minute="$refs.menu.save(time1)"
          color="light-green"
        ></v-time-picker>
      </v-menu>
    </v-col>

    <v-col
      cols="11"
      sm="5"
    >
      <v-menu
        ref="menu3"
        v-model="menu3"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time2"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        color="light-green"
      >
        <template v-slot:activator="{ on, attrs }" color="light-green"> 
          <v-text-field
            v-model="time2"
            label="End time"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
            
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="menu3"
          v-model="time2"
          full-width
          color="light-green"
          format="24hr"
          @click:minute="$refs.menu3.save(time2)"
        ></v-time-picker>
      </v-menu>
    </v-col>
   
    <v-col
      cols="11"
      sm="5"
    >
      <v-select
          :items="speed"
          v-model="fps"
          label="Timelapse Speed"
          item-text="title"
                  item-value="speed"
        ></v-select>
    </v-col>

    <v-col
      cols="11"
      sm="5"
    >
      <v-select
          :items="quality"
          v-model="resolution"
          label="Timelapse Quality"
          item-text="title"
          item-value="quality"
        ></v-select>
    </v-col>

      </v-row>  
      <v-btn
        class="mr-4"
        type="submit"
       
        color="mylightbutton"
      >
        submit
      </v-btn>
      <v-btn @click="clear"
       color="mydarkbutton"
      >
        Reset
      </v-btn>
       </v-card >
    </v-form>
        </v-card>
      </v-tab-item>
      <v-tab-item
        value="tab-2"
        
      >
        <v-card flat>
          <v-alert
      dense
      text
      :type="alertType"
      v-if="alert"
    >
     {{ alertmessage }}
    </v-alert>
          <v-form
    ref="onetimeform"
    @submit.prevent="submitontime"
  > 
       <v-card  class="pa-5" >
        <v-row>
        <v-col
        cols="11"
        sm="5"
        >
           <v-menu
        v-model="startDatemenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
        
      >
        <template v-slot:activator="{ on, attrs }" color="light-green">
          <v-text-field
            v-model="startdate"
            label="Start Date"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
           
          ></v-text-field>
        </template>
        <v-date-picker
          color="light-green"
          v-model="startdate"
          @input="startDatemenu = false"
        ></v-date-picker>
      </v-menu>
        </v-col>

        <v-col
        cols="11"
        sm="5"
        >
           <v-menu
        v-model="enddatemenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
        color="light-green"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="enddate"
            label="End Date"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          color="light-green"
          v-model="enddate"
          @input="enddatemenu = false"
        ></v-date-picker>
      </v-menu>
        </v-col>

        <v-col
      cols="11"
      sm="5"
    >
      <v-menu
        ref="starttimemenu"
        v-model="starttimemenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="starttimetime"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        color="light-green"
      >
        <template v-slot:activator="{ on, attrs }" color="light-green">
          <v-text-field
            v-model="starttimetime"
            label="Start time"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
            format="24hr"
          ></v-text-field>
        </template>
        <v-time-picker
         color="light-green"
          v-if="starttimemenu"
          v-model="starttimetime"
          full-width
          format="24hr"
          @click:minute="$refs.starttimemenu.save(starttimetime)"
        ></v-time-picker>
      </v-menu>
    </v-col>

    <v-col
      cols="11"
      sm="5"
    >
      <v-menu
        ref="endtimemenu"
        v-model="endtimemenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="endtimetime"
        transition="scale-transition"
        offset-y
        max-width="290px"
        color="light-green"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="endtimetime"
            label="End time"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="endtimemenu"
          v-model="endtimetime"
          full-width
          color="light-green"
          format="24hr"
          @click:minute="$refs.endtimemenu.save(endtimetime)"
        ></v-time-picker>
      </v-menu>
    </v-col>
   
    <v-col
      cols="11"
      sm="5"
    >
      <v-select
          :items="speed"
          v-model="fps"
          label="Timelapse Speed"
          item-text="title"
                  item-value="speed"
        ></v-select>
    </v-col>

    <v-col
      cols="11"
      sm="5"
    >
      <v-select
          :items="quality"
          v-model="resolution"
          label="Timelapse Quality"
          item-text="title"
          item-value="quality"
        ></v-select>
    </v-col>

      </v-row>  
      <v-btn
        class="mr-4"
        type="submit"
        
        color="mylightbutton"
      >
        submit
      </v-btn>
      <v-btn @click="clear"
       color="mydarkbutton"
      >
        Reset
      </v-btn>
       </v-card >
    </v-form>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
 </v-card>
    </v-col>
      <v-col
        cols="3"
        md="3"
        out-line
      >
        <Sidebar/>
      </v-col>
    </v-row>
   </div>
</template>
<script>
import axios from 'axios'
import Preloader from '../../../components/PreLoader'
import Sidebar from '../../../components/SettingSidebar'
export default {
  components: {
    Preloader,
      Sidebar
         
  },
  name: "Customiztimelpas",
  data() {
    return { 
        preloader: true,
     
        currentcam : {},
         tab: null,
         time1: null,
         time2: null,
         
         starttimetime: null,
         endtimetime: null,

         startdate : null,
         enddate : null,

        menu2: false,
        menu3: false,

         starttimemenu: false,
        endtimemenu: false,

        startDatemenu : false,

        enddatemenu :false,

        speed: [{speed:24, title: 'Fast'},{speed:15,title: 'Medium'},{speed:10,title: 'Slow'}],
        quality: [{quality:'1280x720', title: 'SD Video(720p)'},{quality:'1920x1080',title: 'HD Video(1080p)'}],
        recurringtype : '',
        currentProject : {},
        alert : false,
        fps : '',
        resolution : '',
      
  }
  },
    computed: {
    params() {
      return {
        type : this.recurringtype, 
        proj_id : this.currentProject.id,
        start_time : this.time1,
        end_time : this.time2,
        timelapse_fps : this.fps,
        ct_resolution : this.resolution
      }
    },

    onetimeparmas() {
      return {
        type : 'onetime', 
        proj_id : this.currentProject.id,
        start_date : this.startdate,
        end_date :  this.enddate,
        start_time : this.starttimetime,
        end_time : this.endtimetime,
        timelapse_fps : this.fps,
        ct_resolution : this.resolution
      }
    }
  }, 
  mounted() {
     this.currentProject = JSON.parse(localStorage.getItem('currentProject'));
     this.initViewer();
      
     
  },
  watch: {
  '$store.state.currentCamera': function() {
     //this.preloader = true
    // console.log("Current data get",this.$store.state.currentCamera);
     this.currentcam = this.$store.state.currentCamera;

      this.gettimeplaseSettings(); 
  }
  }, 
  methods: {
    initViewer() {
     // console.log("init Viewer");
       this.preloader = false 
    
    },
      async submit() {
      //const valid = await this.$refs.form.validate()
         
        this.addrecuring(this.params) // action to login
      
    },
     async submitontime() {
      //const valid = await this.$refs.form.validate()
         
        this.addOnetime(this.onetimeparmas) // action to login
      
    },
    addrecuring(timelapsdata) {
        
        // console.log(timelapsdata)

        axios({ url: '/camera/'+this.currentcam.camera_id+'/timelapse/custom', data: timelapsdata, method: 'POST' })
          .then(resp => {
                    console.log("Resp", resp);
                 if(resp.data.success){

                    this.alert = true;
                    // this.alertmessage = "Recurring Timelapse settings save successful.";
                    this.alertmessage = "You request for new time-lapse video creation will be processed within 1-2 hours. Kindly check the custom time-lapse video under time-lapse video section";
                    this.alertType = "success"

                 }else{

                    this.alert = true;
                    this.alertmessage = resp.data.error;
                    this.alertType = "error"
                 }
       })
          .catch(err => {
            console.log(err);
              this.alert = true;
                    this.alertmessage = "Something went wrong please reload page and try again.";
                    this.alertType = "error"
          })
      },

      addOnetime(timelapsdata) {
        
        //  console.log(this.currentcam)

        axios({ url: '/camera/'+this.currentcam.camera_id+'/timelapse/custom', data: timelapsdata, method: 'POST' })
          .then(resp => {
                    console.log("Resp", resp);
                 if(resp.data.success){

                    this.alert = true;
                    // this.alertmessage = "One time Timelapse settings save successful.";
                    this.alertmessage = "You request for new time-lapse video creation will be processed within 1-2 hours. Kindly check the custom time-lapse video under time-lapse video section";
                    this.alertType = "success"

                 }else{

                    this.alert = true;
                    this.alertmessage = resp.data.error;
                    this.alertType = "error"
                 }
       })
          .catch(err => {
            console.log(err);
                     this.alert = true;
                    this.alertmessage = "Something went wrong please reload page and try again.";
                    this.alertType = "error"
          })
      },

      gettimeplaseSettings() {
        
        axios({ url: '/camera/'+this.currentcam.camera_id+'/timelapse/custom', method: 'GET' })
          .then(resp => {
                   console.log("Resp", resp);
                   
                   if(resp.data.success){
                var res =  resp.data.success;
               this.recurringtype = res.type;
             
              this.startdate = res.start_date;
              this.enddate =res.end_date;
              this.starttimetime = res.start_time;
              this.endtimetime = res.end_time;
              this.fps = res.timelapse_fps;
              this.resolution = res.ct_resolution;

               this.time1 =  res.start_time;
               this.time2 =  res.end_time;
                   }
                 
       })
          .catch(err => {
            console.log(err);
             this.alert = true;
                    this.alertmessage = "Something went wrong please reload page and try again.";
                    this.alertType = "error"
          })
      },
      clear(){
            axios({ url: '/camera/'+this.currentcam.camera_id+'/reset_timelapse_setting', method: 'GET' })
          .then(resp => {
              if(resp.data.success){

                    this.alert = true;
                    this.alertmessage = resp.data.success;
                    this.alertType = "success";
                    this.startdate = '';
              this.enddate = '';
              this.starttimetime = '';
              this.endtimetime = '';
              this.fps = '';
              this.resolution = '';

               this.time1 = '';
               this.time2 = '';

                 }else{

                    this.alert = true;
                    this.alertmessage = "Something went wrong please try again.";
                    this.alertType = "error"
                 }
          })
      }
  }
}
</script>
<style>
 
</style>

